/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import { ServiceInstance } from '../../models/service-instance';
import { ServiceService } from '../../services/service.service';
import { PropertyPatch } from '../../models/property-patch';
import {NgxSpinnerService} from "ngx-spinner";
import { DataObjectUi } from '../infrastructure/dialogs/instance-function.component';
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from '../simple-success-error-dialog-box/simple-success-error-dialog-box.component';
declare var $: any;

@Component({
  selector: 'app-settings-email',
  templateUrl: './settings.email.component.html',
  styleUrls: []
})
export class SettingsEmailComponent implements OnInit, OnChanges {

  /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input() emailAccount;
  serviceInstance: ServiceInstance;

  email_address: string;
  smtp_server_address: string;
  login_id: string;
  password: string;
  port: string;
  is_authentication_required: boolean;
  is_ssl: boolean;
  is_tls: boolean;
  email_to = "";

  /** Array of DataObjectUis that represent the "To Address" values for the Test Email */
  toEmails: DataObjectUi[] = [];

  constructor(
    private services: ServiceService, 
    private spinner: NgxSpinnerService
  ) { }


  ngOnInit(): void {
    // Add a default field for the "To Address" values for testing the settings.
    this.addNewToEmailValue();
  }

  ngOnChanges(): void {
    if (this.emailAccount) {
      // Found the email service
      console.log("email id is " + this.emailAccount.id);
      this.services.getServiceInstanceById(this.emailAccount.id).then(
        response => {
          this.serviceInstance = response;
          this.setEmailSettings();
        },
        error => {
            console.log("Could not get email service instance: " + error);
        });
    }
  }

  private setEmailSettings(): void {
    if (this.serviceInstance.data && this.serviceInstance.data.length > 0) {
      for(const data of this.serviceInstance.data) {
        switch(data.property.property) {
          case "smtp_server_address":
          case "port":
          case "email_address":
          case "login_id":
          case "password":
            this[data.property.property] = data.value;
            break;
          case "is_authentication_required":
          case "is_ssl":
          case "is_tls":
            this[data.property.property] = (data.value == "true");
          break;
        }
      }
    }
  }

  public updateSettingsEmail(): void {
    console.log('Update Email settings');
    this.spinner.show();

    if (this.serviceInstance.data && this.serviceInstance.data.length > 0) {
      for (const data of this.serviceInstance.data) {
        switch (data.property.property) {
          case "smtp_server_address":
          case "port":
          case "email_address":
          case "login_id":
          case "password":
            data.value = this[data.property.property];
            break;
          case "is_authentication_required":
          case "is_ssl":
          case "is_tls":
            data.value = this[data.property.property] ? "true" : "false";
            break;
        }
        data.object_value = this[data.property.property];
      }

    }

    this.services.updateServiceInstance(this.serviceInstance)
      .then(
        response => {
          this.spinner.hide();
          console.log("updateEmailSettings successful");
        },
        error => {
          this.spinner.hide();
          console.log("Error updating email settings: " + error);
          const response: Response = error;
          alert(response.text());
        }
      );
  }


  public ssl_clicked(): void {
    this.is_ssl = $("#is_ssl")[0].checked;
  }

  public tls_clicked(): void {
    this.is_tls = $("#is_tls")[0].checked;
  }

  public authentication_required_clicked(): void {
    this.is_authentication_required = $("#is_authentication_required")[0].checked;
  }

  public showTestEmailSettings(): void {
    const emailSettingsTestEmailDiv = $("#emailSettingsTestEmailDiv");
    if (emailSettingsTestEmailDiv.is(':hidden')) {
      emailSettingsTestEmailDiv.show();
    } else {
      emailSettingsTestEmailDiv.hide();
    }
  }

  public sendTestEmail(): void {
    console.log("this.email_to = [" + this.email_to + "]");
    //const toAddress = $("#email_to").val();
    $("#emailSettingsTestEmailDiv").hide();
    $("#emailSettingsBusyPointer").show();
    console.log("running executeFunction(" + this.emailAccount.id + ",2)");

    const propertyPatches: PropertyPatch[] = [];
    for (const toEmail of this.toEmails) {
      if (toEmail?.value?.length > 0) {
        const propertyPatch =  new PropertyPatch();
        propertyPatch.property = 'to_address';
        propertyPatch.value = toEmail.value;
        propertyPatches.push(propertyPatch);
      }
    }

    this.services.executeFunction(this.emailAccount.id, 2,
      propertyPatches).then(
        response => {
          $("#emailSettingsBusyPointer").hide();
          $("#emailSettingsSuccess").show();
        },
      error => {
          console.log("Could not send test email - error:" + error);
          $("#emailSettingsBusyPointer").hide();
          $("#emailSettingsError").show();
          $("#emailSettingsErrorText").html(error._body);
      }
    );
  }

  public dismissSendTestEmail(): void {
    $("#emailSettingsSuccess").hide();
    $("#emailSettingsError").hide();
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error?.error != null) {
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, error.error);
    } else if (error != null) {
      const response: Response = error;
      alert(response.text());
    }
  }

  /**
   * Called by the UI and during intialization.
   * 
   * Adds a new possible value to the array of "To Email Addresses"
   * to be sent a test email.
   */
  public addNewToEmailValue(): void {
    const dataUi = new DataObjectUi();
    dataUi.value = "";
    this.toEmails.push(dataUi);   
  }

  /**
   * Called by the UI.
   * 
   * Removes the "To Email Address" value from the "toEmails" array
   * at the given index.
   */
  public removeToEmailValueAtIndex(index: number): void {
    this.toEmails.splice(index, 1);
  }

}
